import React, { useState, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import MobileNavbar from "./MobileNavbar/MobileNavbar";
import DesktopNavbar from "./DesktopNavbar/DesktopNavbar";
import "./CustomNavbar.css";

function CustomNavbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = () => {
    setIsNavExpanded(!isNavExpanded);
  };

  const closeNav = () => {
    setIsNavExpanded(false);
  };

  return (
    <>
      {isMobile ? (
        <>
          <Navbar
            className={`py-3 px-4 bg-navbar sticky-top ${
              isNavExpanded ? "z-index-1" : ""
            }`}
          >
            <Navbar.Brand
              as={Link}
              to="/"
              className="text-black navbar-text mx-3"
            >
              פינתי
            </Navbar.Brand>
            <div className="flex-fill"></div>
            <button className="mobile-toggle-button" onClick={handleToggle}>
              ☰
            </button>
          </Navbar>
          {isNavExpanded && <MobileNavbar onClose={closeNav} />}
        </>
      ) : (
        <DesktopNavbar />
      )}
    </>
  );
}

export default CustomNavbar;
